/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 48,
  image: "default-changelog-v2.png",
  title: "New Storage SDK Version, Platform Improvements & Fixes, Documentation Updates",
  shortDescription: "We have published a new version of the Storage SDK. Documentation includes more details about the Storage Organization. We have also released a new version of the Spheron Platform with a couple of improvements and fixes.",
  description: "We have published a new version of the Storage SDK. Documentation includes more details about the Storage Organization. We have also released a new version of the Spheron Platform with a couple of improvements and fixes.",
  date: "Oct 16th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
### [@spheron/storage](https://www.npmjs.com/package/@spheron/storage): New Version v2.0.3
We are excited to announce the release of the latest version of [@spheron/storage](https://www.npmjs.com/package/@spheron/storage). This update brings two valuable new methods to your toolkit - pinUpload and unpinUpload. These methods are designed to enhance your file management capabilities and provide you with greater control over your data.

### Platform Improvements & Fixes

- **Cost Efficiency for Parallel Uploads:** We are committed to delivering more cost-effective solutions. To align with this goal, we have significantly reduced the cost of parallel uploads from $12 to just $2. This cost reduction ensures that you can take full advantage of parallel uploads without breaking the bank.
- **Storage Cleanup on Deployment Deletion:** Beginning today, when you delete IPFS or Filecoin deployments within your organization, the storage space they occupied will be instantly freed up. This enhancement streamlines your storage management and helps you maximize your resources effectively.
- **Organization Bug Issue:** We’ve fixed the issue where organization’s overdue banner was visible even while switching between two organizations.

### Documentation Updates

We're excited to introduce the latest update to our Storage Docs, featuring new sections and features to provide you with enhanced user guidance. Here's what's new:

- **Expanded Buckets Sections:** We've added new sections under Buckets to improve your understanding and usage. These include Uploads, IPNS, and Domains. These additions make it easier utilize the features related to your buckets.
- **Dedicated Gateways:** We've included a new section to Dedicated Gateways under the Storage section.
- **Information and Guides:** You can now find valuable information on rate limits, a comparison between Browser Upload SDK and Storage SDK, an Storage SDK migration guide, encryption and access control details, and a dedicated Billing section. These resources are designed to empower you with comprehensive knowledge and help you make the most out of our storage services.

  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
